import React, { FC, useState } from "react";
import { Link as LinkRouter} from "react-router-dom";
// @ts-ignore
import { Link } from "react-scroll";

const Header: FC = () => {
    const [menuIsOpened, setMenuIsOpened] = useState<boolean>(false);

    const handleMenu = () => {
        setMenuIsOpened(!menuIsOpened);
    };

    return (
        <header className="header">
            <nav className="navbar">
                <LinkRouter to="/" className="nav-branding" onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth'})}>
                    CrossGYM
                </LinkRouter>

                <ul className={menuIsOpened ? "nav__menu active" : "nav__menu"}>
                    <li className="nav__menu-item">
                        <Link
                            onClick={handleMenu}
                            to="about"
                            smooth={true}
                            className="nav__menu-link"
                        >
                            Про нас
                        </Link>
                    </li>
                    <li className="nav__menu-item">
                        <Link
                            onClick={handleMenu}
                            to="memberships"
                            smooth={true}
                            className="nav__menu-link"
                        >
                            Абонементи
                        </Link>
                    </li>
                    <li className="nav__menu-item">
                        <Link
                            onClick={handleMenu}
                            to="trainers"
                            smooth={true}
                            className="nav__menu-link"
                        >
                            Тренери
                        </Link>
                    </li>
                    <li className="nav__menu-item">
                        <Link
                            onClick={handleMenu}
                            to="halls"
                            smooth={true}
                            className="nav__menu-link"
                        >
                            Зали
                        </Link>
                    </li>
                    <li className="nav__menu-item">
                        <a
                            href="https://t.me/crossgym_kr"
                            className="nav__menu-link"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <img
                                width="24"
                                height="24"
                                src="https://img.icons8.com/ios-glyphs/30/ffffff/telegram-app.png"
                                alt="telegram-app"
                            />
                        </a>
                    </li>
                    <li className="nav__menu-item">
                        <a
                            href="https://www.instagram.com/crossgym_baza_team/"
                            className="nav__menu-link"
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            <img
                                width="24"
                                height="24"
                                src="https://img.icons8.com/material-outlined/24/ffffff/instagram-new--v1.png"
                                alt="instagram-new--v1"
                            />
                        </a>
                    </li>
                </ul>

                <div className="hamburger" onClick={handleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </nav>
        </header>
    );
};

export default Header;
